<div class="container">
    <figure class="img-container">
        <img id="logo" src="{{logo}}" width="120px" height="120px"/>
    </figure>
    <span>{{text}}<p class="line anim-typewriter">...</p></span>
</div>